export const allArticles = [
  {
    id: 1,
    title: '聽力退化悄悄來，您注意到了嗎？',
    summary: '聽力損失往往在無聲無息中發生，許多人直到家人提醒才發現問題。了解早期徵兆，及早守護聽力健康。',
    content: '聽力退化是一種緩慢進行的過程，許多人在初期並不察覺。常見的早期徵兆包括：聽不清電話對話、常要求他人重複說話、在嘈雜環境中聽不清楚、將電視音量開得比別人大。如果您或家人出現這些情況，建議盡早進行專業聽力檢測。研究顯示，及早發現並配戴助聽器，可以有效延緩聽力進一步退化，並維持大腦的語言處理能力。',
    category: '聽力保健',
    date: '2026-05-15',
    readTime: 5,
    image: 'https://readdy.ai/api/search-image?query=elderly%20person%20checking%20hearing%20with%20audiologist%20in%20modern%20clinic%20warm%20lighting%20professional%20atmosphere%20green%20tones&width=600&height=400&seq=20&orientation=landscape',
    author: '林聽力師',
  },
  {
    id: 2,
    title: '助聽器選購指南：找到最適合您的聽力夥伴',
    summary: '市面上助聽器種類繁多，從耳掛式到耳道式，從基本款到智能款，該怎麼選？本文帶您了解選購重點。',
    content: '選購助聽器前，首先需要接受專業聽力檢測，了解聽損類型與程度。耳掛式助聽器適合各種程度的聽損，且電池壽命較長；耳道式助聽器隱蔽性較好，但功率相對較小。此外，是否需要藍牙功能、充電式設計、App 調節等，都應根據個人生活型態與預算來決定。建議選擇有完善售後服務的品牌，並定期回廠調整。',
    category: '助聽器保養',
    date: '2026-05-10',
    readTime: 8,
    image: 'https://readdy.ai/api/search-image?query=various%20hearing%20aid%20devices%20arranged%20on%20soft%20white%20surface%20product%20comparison%20photography%20minimalist%20professional%20lighting&width=600&height=400&seq=21&orientation=landscape',
    author: '王選配師',
  },
  {
    id: 3,
    title: '噪音環境下的聽力防護',
    summary: '現代生活充斥著各種噪音，長期暴露可能造成不可逆的聽力損傷。學會正確的防護方法，保護您寶貴的聽力。',
    content: '根據世界衛生組織統計，全球約有 4.3 億人受到聽力損失的影響，其中約有一半的病例可以預防。職業噪音、長時間使用耳機、參加音樂會等都可能造成聽力損傷。建議在噪音環境中佩戴耳塞或耳罩，使用耳機時遵守「60/60 原則」：音量不超過最大音量的 60%，每次使用不超過 60 分鐘。',
    category: '噪音防護',
    date: '2026-05-05',
    readTime: 6,
    image: 'https://readdy.ai/api/search-image?query=person%20wearing%20hearing%20protection%20earplugs%20in%20noisy%20environment%20safety%20health%20awareness%20soft%20professional%20photography&width=600&height=400&seq=22&orientation=landscape',
    author: '張聽力師',
  },
  {
    id: 4,
    title: '兒童聽力篩檢：別讓聽力問題影響成長',
    summary: '兒童聽力問題若未及早發現，可能影響語言發展與學習能力。了解聽力篩檢的重要性與時機。',
    content: '新生兒聽力篩檢是辨識先天性聽損的第一道防線。若篩檢未通過，應在三個月內完成進一步診斷。即使新生兒篩檢通過，家長也應持續觀察孩子的聽覺反應。3 歲前是語言發展的黃金期，若有聽力問題，應盡早配戴助聽器並進行語言治療，才能讓孩子正常發展溝通能力。',
    category: '兒童聽力',
    date: '2026-04-28',
    readTime: 7,
    image: 'https://readdy.ai/api/search-image?query=child%20having%20hearing%20test%20with%20pediatric%20audiologist%20warm%20friendly%20clinic%20environment%20colorful%20professional%20photography&width=600&height=400&seq=24&orientation=landscape',
    author: '李聽力師',
  },
  {
    id: 5,
    title: '助聽器日常保養與清潔',
    summary: '正確的保養可以延長助聽器壽命並維持最佳音質。學習簡單的日常清潔步驟，讓助聽器陪伴您更久。',
    content: '助聽器每天與皮膚接觸，難免累積耳垢、油脂與濕氣。建議每晚使用柔軟乾布擦拭外殼，並用專用清潔工具清理耳塞或耳模。充電式助聽器應每晚放回充電盒，電池式則應取出電池避免漏液。此外，每 3-6 個月回門市進行專業清潔與保養，可以確保助聽器維持最佳狀態。',
    category: '助聽器保養',
    date: '2026-04-20',
    readTime: 4,
    image: 'https://readdy.ai/api/search-image?query=hearing%20aid%20cleaning%20tools%20and%20maintenance%20kit%20on%20soft%20white%20surface%20product%20photography%20professional%20lighting&width=600&height=400&seq=25&orientation=landscape',
    author: '王選配師',
  },
  {
    id: 6,
    title: '雙耳聽損為何要雙耳配戴助聽器？',
    summary: '許多人認為一隻耳朵聽得見就夠了，但雙耳聽損只配單耳，可能帶來更多問題。',
    content: '雙耳聽覺對於聲音定位、噪音環境下的語音理解非常重要。單耳配戴助聽器會造成「頭影效應」，聲音從未配戴側傳來時會被頭部阻擋，導致聽不清楚。此外，長期單耳助聽會讓大腦漸漸忽略未配戴側的聲音，造成聽力剝奪。對於雙耳聽損者，專業聽力師強烈建議雙耳同時配戴。',
    category: '聽力保健',
    date: '2026-04-12',
    readTime: 5,
    image: 'https://readdy.ai/api/search-image?query=person%20wearing%20hearing%20aids%20in%20both%20ears%20close%20up%20portrait%20soft%20natural%20lighting%20professional%20health%20photography&width=600&height=400&seq=26&orientation=landscape',
    author: '林聽力師',
  },
  {
    id: 7,
    title: '耳鳴警訊：當耳朵開始嗡嗡響時該怎麼辦？',
    summary: '耳鳴不只是小困擾，可能是聽力問題的警訊。了解耳鳴的成因、影響與應對方式，別讓忽視造成遺憾。',
    content: '耳鳴是指在沒有外界聲音的情況下，耳朵或頭部持續聽到嗡嗡聲、鈴聲或嘶嘶聲。雖然耳鳴本身不是疾病，但往往是聽力系統出現問題的警訊。常見成因包括長期噪音暴露、耳垢堵塞、聽力退化、壓力過大、高血壓等。若耳鳴持續超過兩週，或伴隨聽力下降、頭暈等症狀，建議盡快尋求專業聽力檢查。部分耳鳴可以透過治療改善，但若為慢性耳鳴，助聽器或聲音治療也能有效減輕困擾。',
    category: '耳鳴專題',
    date: '2026-06-03',
    readTime: 6,
    image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20ear%20with%20tinnitus%20awareness%20concept%20soft%20abstract%20sound%20wave%20visualization%20around%20ear%20warm%20green%20tones%20professional%20medical%20illustration&width=600&height=400&seq=27&orientation=landscape',
    author: '林聽力師',
  },
];

export const knowledgeCategories = ['全部', '聽力保健', '助聽器保養', '噪音防護', '兒童聽力', '耳鳴專題'];